import {Row, Col, Input, Form, Button} from 'antd';

const MeetingRoomInputs = ({error, onSetMeetingRoomDrawer}) => {
    return (
        <Row gutter={15}>
          <Col xs={24} lg={12}>
            <Row gutter={15}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="name"
                  label="نام خدمت"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام خدمت را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder="نام خدمت" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Button
                  onClick={() => onSetMeetingRoomDrawer(true)}
                  type="primary"
                  style={{ marginTop: 30 }}
                >
                  تعهدنامه
                </Button>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item label="توضیحات" name="description">
                  <Input.TextArea rows={2} placeholder="توضیحات" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
    );
};

export default MeetingRoomInputs;